import React from 'react';
import {FormattedMessage} from 'react-intl';
import config from "../config/common";
import styles from "../components/ErrorMessage/styles.module.scss";

export const errors = {
  REQUIRED_FIELD: <FormattedMessage id={'common.errors.required'} defaultMessage={'Field is required'} />,
  INVALID_ID: <FormattedMessage id={'common.errors.invalidId'} defaultMessage={'Id is invalid'} />,
  COMMON_ERROR: (
    <FormattedMessage
      id={"common.error.message"}
      values={{
        a: str => <a href={`mailto:${config.supportEmail}`} className={styles.mailToSupport}>{str}</a>
      }}
    />
  ),
  STEP_15_WRONG_FILE: <FormattedMessage id={"step15.form.uploadFile.error"} defaultMessage={'File type is not allowed'} />,
  STEP_2_UNDER_16: <FormattedMessage id={"step2.form.birthDateUnder16.error"} defaultMessage={'You are too little guy, do you know it?'} />,
  STEP_12_UNDER_19: <FormattedMessage id={"step12.form.childrenUnder19.error"} defaultMessage={'Congratulations! You have children under 19!'} />,
  STEP_2_ID_IMAGE_NAME_OR_ID_ERROR: <FormattedMessage id={"step2.form.checkIdImage.nameOrId.error"} defaultMessage={'The details entered do not match the attached image. Please check and try again or contact support.'} />,
  STEP_2_ID_IMAGE_GENERAL_ERROR: <FormattedMessage id={"step2.form.checkIdImage.general.error"} defaultMessage={'The attached image was not recognized as a valid ID card. Please check the image quality and make sure it is correct and try again or contact support.'} />,
};
